exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pVB7v{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._36ze2>button,._36ze2>input{margin:5px 0}._36ze2{margin-top:20px}._11Vg_,.plzaW{position:relative;color:#d7433d;font-weight:400;font-size:13px;text-align:center;display:block;line-height:1.2;min-height:20px}._11Vg_{color:#2c7e07;font-size:15px;font-weight:500}.pm8fX{font-weight:700;font-size:16px;line-height:22px;color:#000}._4BY2Y{font-style:normal}._2Y2L0,._4BY2Y,.yCu68{margin-top:20px;font-weight:400;font-size:14px;line-height:140%}.yCu68{margin-bottom:10px}.yCu68>label{margin-top:10px;display:block;cursor:pointer}.yCu68>label>input{margin-right:6px}._3QY6s{font-weight:400;font-size:12px;line-height:140%;color:gray;margin-top:10px;margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"containerCenter": "pVB7v",
	"requestForm": "_36ze2",
	"errorMessage": "plzaW",
	"successMessage": "_11Vg_",
	"title": "pm8fX",
	"subTitle": "_4BY2Y",
	"contentText": "_2Y2L0",
	"searchTypeBlock": "yCu68",
	"footer": "_3QY6s"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/SuggestForDefaultAd/SuggestForm/CommonEmailForm.css
// module id = 2259
// module chunks = 1 17 20